import { Autocomplete, TextField, Box, Chip } from "@mui/material"
import { useState, useEffect } from "react"
import { Tags as API } from "../../../services/API/Tags";

export default function RelatedTags({id, required}){

    const [tags, setTags] = useState([]);
    const [values, setValues] = useState([])

    useEffect(() => {

        API.getOne(id)
            .then(r => setValues(r.data.relatedTags || []))
            .catch(e => console.log(e))

        API.getAll()
            .then(r => {
                const items = Array.isArray(r.data) ? r.data : [];
                return setTags(items);
            })
            .catch(e => console.log(e))
    }, [id])

    const handleChange = tv => {
        let tag = tags.find(t => tagTitle(t) === tv);
        if(!tag) return false;

        API.link(id, tag.id)
            .then(r => console.log(r.data))
            .catch(e => console.log(e));

        let copy = [...values];
        copy = copy.filter(t => t.id !== tag.id);
        copy.unshift(tag);
        return setValues(copy);
    }

    const handleDelete = tagId => {

        API.deleteLink(id, tagId)
            .then(r => console.log(r.data))
            .catch(e => console.log(e));

        let copy = [...values];
        copy = copy.filter(t => t.id !== tagId);
        return setValues(copy);
    }

    const tagTitle = t => t.type.title + ' : ' + t.title;

    return <>
        <Autocomplete
            options={(tags || []).map(t => tagTitle(t))}
            renderInput={params => <TextField 
                {...params}
                label='Mots clés liés'
                size='small'
                required={required}
            />}
            value={null}
            onChange={(e, v) => handleChange(v)}
            blurOnSelect
        />
        <Box>
            {values.map(v => 
                <Chip 
                    key={v.id} 
                    label={v.title} 
                    onDelete={() => handleDelete(v.id)} 
                    sx={{mt: 1, mr: 1}}
                />    
            )}
        </Box>
    </>
}